import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';
import { Collapse } from 'bootstrap';
import ShowIpgTransactionResult from './ShowIpgTransactionResult';


export default function PersianVerifyPayment(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [verifying, setVerifying] = useState(true);
    const [searchParams] = useSearchParams();
    const isok = searchParams.get("isok");
    const msg = searchParams.get("msg");
    const transactionid = searchParams.get("transactionid");
    const token = searchParams.get("token");
    const [transactionResult, setTransactionResult] = useState({});

    useEffect(() => {

        if(transactionid == "-"){
            var result = {
                hasError:true,
                transactionDate:0,
                transactionTime:0,
                contractNo:0,
                amount:0,
                continueLink:"",
                messages:[msg],
                walletTransactionType:{id:0, title:""},
                traceNo:"",
            };
            setTransactionResult(result);
            setVerifying(false);
        }
        else{
            setVerifying(true);
            var params = {
                param1:transactionid, 
                param2:"", 
                param3:"", 
                param4:"", 
                param5:"", 
            };
            var url = config.Server+`/payment/ipg-transaction/detail/get`;
            if(isok == "0"){
                url = config.Server+`/payment/ipg-transaction/get`;
            }
            
            axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    const transResult = response.data;
                    console.log("trans result is>", transResult)
                    var result = {
                        hasError:false,
                        transactionDate:0,
                        transactionTime:0,
                        contractNo:0,
                        amount:0,
                        continueLink:"",
                        messages:[msg],
                        walletTransactionType:{id:0, title:""},
                        traceNo:"",
                    };
                    if(isok == "0"){
                        result.transactionDate = transResult.transactionDate;
                        result.transactionTime = transResult.transactionTime;
                        result.amount = transResult.amount;
                        result.messages.push(transResult.message);
                    }
                    else{
                        result = transResult;
                        result.hasError = false;
                    }
                    setTransactionResult(result);
                    setVerifying(false);
                }
                else{
                    var result = {
                        hasError:true,
                        transactionDate:0,
                        transactionTime:0,
                        contractNo:0,
                        amount:0,
                        continueLink:"",
                        messages:[msg, res.data.message],
                        walletTransactionType:{id:0, title:""},
                        traceNo:"",
                    };
                    setTransactionResult(result);
                }
                setVerifying(false);
            })
            .catch(err => {
                var result = {
                    hasError:true,
                    transactionDate:0,
                    transactionTime:0,
                    contractNo:0,
                    amount:0,
                    continueLink:"",
                    messages:[msg, err.message],
                    walletTransactionType:{id:0, title:""},
                    traceNo:"",
                };
                setTransactionResult(result);
                setVerifying(false);
            });

        }
        
    }, [token]);
    
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (verifying === true)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت مشخصات تراکنش..." />
                </Col>
            </Row>
        </>
        :
        <>
            <ShowIpgTransactionResult result={transactionResult} />
        </>
    )
}